import { WorkOrderStatus } from "@model/workOrders/WorkOrder"

/**
 * Action Item #11164: whether the fields that stay hard-locked on a Closed Work Order accept
 * edits — the Physical Hour Meter, Physical Odometer, Completion Date, and the Status dropdown
 * all share this rule.
 *
 * Once a Work Order is Closed those values are historical facts: entering closed-WO edit mode
 * unlocks the other fields but must NOT unlock these. That is why closedWorkOrderEditMode
 * deliberately has no parameter here. A null/undefined status means the Work Order is unsaved
 * or the edit-mode fetch has not resolved yet — both editable, matching the previous inline
 * expressions.
 */
export function canEditClosedLockedField(
    status: WorkOrderStatus | null | undefined,
    hasEditPermission: boolean,
    isOnHold: boolean
): boolean {
    if (!hasEditPermission) return false
    if (isOnHold) return false
    return status !== WorkOrderStatus.Closed
}
